import gql from "graphql-tag";

export const INSERT_REDEEM_POINTS = gql`
mutation insert_Redemption($id:uuid!,$createdBy:uuid!, $partnerId:uuid!, $schemeId:uuid!, $goalId:uuid, $points:Int!, $status:String!, $lastUpdatedBy:uuid!, $approvedBy:uuid, $rejectedBy:uuid, $updatedOn:timestamptz!,$goalName:String){
  insert_Redemption(objects: {id:$id, createdBy:$createdBy, partnerId:$partnerId, schemeId:$schemeId, goalId:$goalId, points:$points, status:$status, lastUpdatedBy:$lastUpdatedBy ,approvedBy:$approvedBy, rejectedBy:$rejectedBy, updatedOn:$updatedOn,goalName:$goalName})
  {returning{
  id
  }}
}
`
